module.exports = __webpack_public_path__ + "img/3.92b83482.png";